import { Button, HStack, Text } from "@chakra-ui/react";

import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import ReactPaginate from "react-paginate";

import { Paginated } from "@/jenesys-types/data/common";

interface PaginateProps {
  page: number;
  data: Paginated<any>;
  handlePageClick: (event: { selected: number }) => void;
}

export const Paginate: React.FC<PaginateProps> = ({
  page,
  data,
  handlePageClick
}) => {
  if (!data.total) return null;

  const total = Number(data.total);
  const limit = Number(data.limit);
  const offset = Number(data.offset);
  const totalPages = Math.ceil(total / limit);

  const firstPage = Math.floor(offset) + 1;
  const lastPage = Math.min(firstPage + limit - 1, total);

  return (
    <HStack>
      <ReactPaginate
        previousLabel={
          <Button size="sm" variant="ghost" leftIcon={<ChevronLeftIcon />}>
            Prev
          </Button>
        }
        nextLabel={
          <Button size="sm" variant="ghost" rightIcon={<ChevronRightIcon />}>
            Next
          </Button>
        }
        breakLabel="..."
        breakClassName="break"
        forcePage={page}
        pageCount={totalPages}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        disableInitialCallback
        onPageChange={handlePageClick}
        containerClassName="pagination"
        activeClassName="active"
      />
      <Text fontSize={14}>
        {firstPage}-{lastPage} of {total}
      </Text>
    </HStack>
  );
};
